const supportedLocales = ['es', 'pt', 'de', 'fr', 'it'];

module.exports = { supportedLocales };
